import { render, staticRenderFns } from "./RatingCardAdmin.vue?vue&type=template&id=d72f24dc&scoped=true"
import script from "./RatingCardAdmin.vue?vue&type=script&lang=js"
export * from "./RatingCardAdmin.vue?vue&type=script&lang=js"
import style0 from "./RatingCardAdmin.vue?vue&type=style&index=0&id=d72f24dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72f24dc",
  null
  
)

export default component.exports